"use server";

import { unscopedPrisma } from "@/lib/db";
import { recordPlatformOpsEvent } from "@/lib/platform/ops-event";
import {
  isWaitlistDuplicateError,
  parseWaitlistLead,
  waitlistCopy,
  waitlistSuccessMessage,
} from "@/lib/ui/landing";
import { platformCopy } from "@/lib/ui/platform";
import { syncWaitlistLead } from "@/lib/yougile/sync";

export type WaitlistState = {
  error: string | null;
  message: string | null;
};

export async function submitWaitlistAction(
  _prev: WaitlistState,
  formData: FormData,
): Promise<WaitlistState> {
  const parsed = parseWaitlistLead({
    name: String(formData.get("name") ?? ""),
    email: String(formData.get("email") ?? ""),
    company: String(formData.get("company") ?? ""),
    deployment: String(formData.get("deployment") ?? ""),
    comment: String(formData.get("comment") ?? ""),
  });
  if (!parsed.ok) {
    return { error: parsed.error, message: null };
  }

  try {
    await unscopedPrisma.waitlistLead.create({
      data: parsed.value,
    });
    await recordPlatformOpsEvent({
      category: "waitlist",
      severity: "info",
      subject: parsed.value.company.trim() || parsed.value.name,
      message: platformCopy.opsJournalWaitlistMessage,
    });
    try {
      await syncWaitlistLead(parsed.value);
    } catch (error) {
      console.error(
        "YouGile waitlist sync skipped",
        error instanceof Error ? error.message : "error",
      );
    }
    return { error: null, message: waitlistSuccessMessage(false) };
  } catch (error) {
    if (isWaitlistDuplicateError(error)) {
      return { error: null, message: waitlistSuccessMessage(true) };
    }
    return { error: waitlistCopy.error, message: null };
  }
}
